import Repository from '../../repositories/RepositoryFactory';
const inventoryItems = Repository.get('inventoryItems');

export default {
	namespaced: true,
	state: {
		inventoryItems: [],
		selectedInventoryItem: {},
		selectedItemCatalog: null,
		itemStatusOptions: [],
		itemConditionOptions: [],
	},
	mutations: {
		SET_INVENTORY_ITEMS (state, payload) {
			state.inventoryItems = payload;
		},
		SET_INVENTORY_ITEM (state, payload) {
			state.selectedInventoryItem = payload;
		},
		SET_ITEM_STATUS_OPTIONS (state, payload) {
			state.itemStatusOptions = payload;
		},
		SET_INVENTORY_ITEM_CATALOG (state, payload) {
			state.selectedItemCatalog = payload;
		},
		SET_ITEM_CONDITION_OPTIONS (state, payload) {
			state.itemConditionOptions = payload;
		},
		DELETE_INVENTORY_ITEM (state, id) {
			state.inventoryItems = state.inventoryItems.filter((item) => item.id !== id);
			if (state.selectedInventoryItem.id === id) {
				state.selectedInventoryItem = {};
			}
		},
	},
	actions: {
		async getInventoryItems ({ commit }) {
			commit('SET_INVENTORY_ITEMS', await inventoryItems.getInventoryItems());
		},
		async getInventoryItemById ({ commit }, id) {
			commit('SET_INVENTORY_ITEM', await inventoryItems.getInventoryItemById(id));
		},
		async getInventoryItemStatusOptions ({ commit }) {
			commit('SET_ITEM_STATUS_OPTIONS', await inventoryItems.getInventoryItemStatusOptions());
		},
		async getInventoryItemConditionOptions ({ commit }) {
			commit('SET_ITEM_CONDITION_OPTIONS', await inventoryItems.getInventoryItemConditionOptions());
		},
		async addInventoryItem ({ commit }, body) {
			await inventoryItems.addInventoryItem(body);
		},
		async editInventoryItem ({ commit }, body) {
			await inventoryItems.editInventoryItem(body);
		},
		async deleteInventoryItem ({ commit }, id) {
			await inventoryItems.deleteInventoryItem(id);
			commit('DELETE_INVENTORY_ITEM', id);
		},
	},
};
